export default __webpack_public_path__ + "static/media/presets.f3c8642e.gif";